import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {ComponentUtils, DetailActions, getRouter, getStore} from 'simplifyworks-core-ui';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
	getCoreNativeCodebooks,
	getLoggedUserCountry,
	getLoggedUserFoedusPerson,
	getNewOrganOfferDefaultValues,
	getNewOrganRequestDefaultValues,
	getOrganOfferAttachmentTypeCbIds,
	getOrganOfferGuid,
	getOrganRequestGuid,
	getShowGrantAnonymousAccessActionButton,
	getShowMessageActionButton,
	getShowNotificationActionButton
} from './rest';
import {
	hideGrantAnonymousAccessActionButton,
	hideMessageActionButton,
	hideNotificationActionButton,
	setCountryCoreCodebook,
	setFoedusRoleNamesFilter,
	setLoggedUserCountry,
	setLoggedUserFoedusPerson,
	setLoggedUserPrimaryFoedusRole,
	setNationalBodyCoreCodebook,
	setOrganOfferAttachmentTypeCbIds,
	showGrantAnonymousAccessActionButton,
	showMessageActionButton,
	showNotificationActionButton
} from './redux/actions/foedus';
import {FOEDUS_ROLE} from './domain/constants';
import {getElementAfter} from './utils';

const TEMPORARY_USER_STYLE_ID = 'core-temporary-user-tweaks';

const ReduxStateUpdater = (props) => {
	const [defaultValuesApplied, setDefaultValuesApplied] = useState(false);
	const [defaultValuesForAcceptOfferApplied, setDefaultValuesForAcceptOfferApplied] = useState(false);
	const [organOfferGuid, setOrganOfferGuid] = useState(null);
	const [organRequestGuid, setOrganRequestGuid] = useState(null);
	const pathname = getRouter()?.state?.location?.pathname;

	// Pri docasnom uzivatelovi potrebujem niektore core linky a komponenty nezobrazovat
	useEffect(() => {
		const css = `
		  .dropdown-menu[aria-labelledby="user-menu"] > :not(:last-child) {
			display: none;
		  }
		  .core-breadcrumbs-clickable {
			pointer-events: none;
		  }
		  .navbar-brand {
			pointer-events: none;
		  }
    	`;

		let styleEl = document.getElementById(TEMPORARY_USER_STYLE_ID);

		if (props?.isTemporaryUser) {
			if (!styleEl) {
				styleEl = document.createElement('style');
				styleEl.id = TEMPORARY_USER_STYLE_ID;
				styleEl.type = 'text/css';
				styleEl.appendChild(document.createTextNode(css));
				document.head.appendChild(styleEl);
			}
		} else {
			if (styleEl) {
				styleEl.remove();
			}
		}

		return () => {
			document.getElementById(TEMPORARY_USER_STYLE_ID)?.remove();
		};
	}, [props?.isTemporaryUser]);

	useEffect(() => {
		if (
			props?.router?.location?.pathname.includes('/ood/entries/new')
			&& !props?.router?.location?.pathname.includes('parent')
		) {
			getOrganOfferGuid(
				(data) => {
					setOrganOfferGuid(data);
				}
			);

			getOrganRequestGuid(
				(data) => {
					setOrganRequestGuid(data);
				}
			);
		}

		// TODO: Optimalizovat
		if (!props?.organOfferAttachmentTypeCbIds) {
			getOrganOfferAttachmentTypeCbIds(
				(data) => {
					getStore().dispatch(
						setOrganOfferAttachmentTypeCbIds(
							{
								organOfferAttachmentTypeCbIds: data
							}
						)
					);
				}
			);
		}

		if (!props?.nationalBodyCoreCodebook) {
			getCoreNativeCodebooks(
				{
					codebookType: 'CoreOrganizationTypeCodebook',
					code: '1'
				},
				(data) => {
					if (data?.resources?.length > 0) {
						getStore().dispatch(
							setCountryCoreCodebook(
								{
									countryCoreCodebook: data?.resources[0]
								}
							)
						);
					}
				}
			);
		}

		if (!props?.nationalBodyCoreCodebook) {
			getCoreNativeCodebooks(
				{
					codebookType: 'CoreOrganizationTypeCodebook',
					code: '2'
				},
				(data) => {
					if (data?.resources?.length > 0) {
						getStore().dispatch(
							setNationalBodyCoreCodebook(
								{
									nationalBodyCoreCodebook: data?.resources[0]
								}
							)
						);
					}
				}
			);
		}

	}, []);

	useEffect(() => {
		const roles = props?.loggedUserRoles;
		let primaryRole = null;

		if (roles?.includes(FOEDUS_ROLE.ADMIN)) {
			primaryRole = FOEDUS_ROLE.ADMIN;
		} else if (roles?.includes(FOEDUS_ROLE.COUNTRY_MANAGER)) {
			primaryRole = FOEDUS_ROLE.COUNTRY_MANAGER;
		} else if (roles?.includes(FOEDUS_ROLE.COORDINATOR)) {
			primaryRole = FOEDUS_ROLE.COORDINATOR;
		}

		getStore().dispatch(
			setLoggedUserPrimaryFoedusRole(
				{
					loggedUserPrimaryFoedusRole: primaryRole
				}
			)
		);
	}, [props?.loggedUserRoles]);

	useEffect(() => {
		const { loggedUserPrimaryFoedusRole } = props;
		let foedusRoleNamesFilter = [];

		if (loggedUserPrimaryFoedusRole === FOEDUS_ROLE.COUNTRY_MANAGER) {
			foedusRoleNamesFilter = [FOEDUS_ROLE.COORDINATOR];
		} else if (loggedUserPrimaryFoedusRole === FOEDUS_ROLE.ADMIN) {
			foedusRoleNamesFilter = [FOEDUS_ROLE.COORDINATOR, FOEDUS_ROLE.COUNTRY_MANAGER];
		}

		getStore().dispatch(
			setFoedusRoleNamesFilter(
				{
					foedusRoleNamesFilter
				}
			)
		);

		getLoggedUserCountry(
			(data) => {
				getStore().dispatch(
					setLoggedUserCountry(
						{
							loggedUserCountry: data
						}
					)
				);
			}
		);

		getLoggedUserFoedusPerson(
			(data) => {
				getStore().dispatch(
					setLoggedUserFoedusPerson(
						{
							loggedUserFoedusPerson: data
						}
					)
				);
			}
		);

	}, [props?.currentUserId, props.loggedUserPrimaryFoedusRole]);

	useEffect(() => {
		if (props?.entryId && props?.entryId !== 'new') {
			getShowNotificationActionButton(
				props?.entryId,
				(data) => {
					getStore().dispatch(
						(data ? showNotificationActionButton : hideNotificationActionButton)({
							showNotificationActionButton: data
						})
					);
				}
			);

			getShowMessageActionButton(
				props?.entryId,
				(data) => {
					getStore().dispatch(
						(data ? showMessageActionButton : hideMessageActionButton)({
							showMessageActionButton: data
						})
					);
				}
			);

			getShowGrantAnonymousAccessActionButton(
				props?.entryId,
				(data) => {
					getStore().dispatch(
						(data ? showGrantAnonymousAccessActionButton : hideGrantAnonymousAccessActionButton)({
							showGrantAnonymousAccessActionButton: data
						})
					);
				}
			);
		}
	}, [props?.entryId, pathname]);

	// TODO: Pravdepodobne sa zahodi - organ offers budu vytvarat z custom modalu a portletu
	// Setovanie default values pre organ offer (ORG, COUNTRY)
	useEffect(() => {
		if (
			props?.foundFormForCountry
			&& props?.foundFormKeyForCountry
			&& props?.currentDefinition?.definitionGuid === organOfferGuid
			&& !props.newEntryDetail?.modified
			&& !defaultValuesApplied
		) {
			getNewOrganOfferDefaultValues(
				(defaultValuesOverride) => {
					const clonedData = {...props.foundFormForCountry};

					props.actions.detail.formInit(
						'/api/ood/entries/new',
						props.foundFormKeyForCountry,
						null,
						null,
						{
							...clonedData,
							dfValues: {
								...clonedData.dfValues,
								...defaultValuesOverride
							}
						}
					);

					setDefaultValuesApplied(true);
				},
				() => {
					console.error('Nepodarilo se nacitat vychozi hodnoty.');
				}
			);
		}
	}, [props?.foundFormForCountry, organOfferGuid, defaultValuesApplied]);

	// TODO: Pravdepodobne sa zahodi - organ offers budu vytvarat z custom modalu a portletu
	// Setovanie default values pre organ request (ORG, COUNTRY)
	useEffect(() => {
		if (
			props?.foundFormForCountry
			&& props?.foundFormKeyForCountry
			&& props?.currentDefinition?.definitionGuid === organRequestGuid
			&& !props.newEntryDetail?.modified
			&& !defaultValuesApplied
		) {
			getNewOrganRequestDefaultValues(
				(defaultValuesOverride) => {
					const clonedData = {...props.foundFormForCountry};

					props.actions.detail.formInit(
						'/api/ood/entries/new',
						props.foundFormKeyForCountry,
						null,
						null,
						{
							...clonedData.data,
							dfValues: {
								...clonedData.data.dfValues,
								...defaultValuesOverride
							}
						}
					);

					setDefaultValuesApplied(true);
				},
				() => {
					console.error('Nepodarilo se nacitat vychozi hodnoty.');
				}
			);
		}
	}, [props?.foundFormForCountry, organRequestGuid, defaultValuesApplied]);

	// TODO: Pravdepodobne sa zahodi - organ offers budu vytvarat z custom modalu a portletu
	// Setovanie default values pre accept organ offer (ORG_INT)
	useEffect(() => {
		if (
			props?.foundFormForCountryExpressingInterest
			&& props?.foundFormKeyForCountryExpressingInterest
			// TODO: porovnavat aj s parent definition id
			&& props?.router?.location?.pathname?.includes('parent')
			&& !props.newEntryDetail?.modified
			&& !defaultValuesForAcceptOfferApplied
		) {
			if (props?.loggedUserCountry) {
				const clonedData = {...props.foundFormForCountryExpressingInterest};

				// TODO: skusit to napasovat na formInit - P4
				props.actions.detail.changeValue(
					'/api/ood/entries/new',
					props.foundFormKeyForCountryExpressingInterest,
					'dfValues',
					{
						...clonedData.dfValues,
						ORG_INT: {
							organization: props?.loggedUserCountry
						}
					}
				);

				setDefaultValuesForAcceptOfferApplied(true);
			}
		}
	}, [props?.foundFormForCountryExpressingInterest, defaultValuesForAcceptOfferApplied, props?.loggedUserCountry]);

	return null;
};

ReduxStateUpdater.propTypes = {
	title: PropTypes.node.isRequired,
	main: PropTypes.node.isRequired
};

const mapStateToProps = (state, ownProps) => {
	const newEntryDetail = ComponentUtils.getDetail(state, '/api/ood/entries/new');

	// Predvyplnenie pri organ offer a organ request
	let foundFormForCountry = null;
	let foundFormKeyForCountry = null;

	// Predvyplnenie pri accept organ offer
	let foundFormForCountryExpressingInterest = null;
	let foundFormKeyForCountryExpressingInterest = null;

	for (const [key, form] of Object.entries(newEntryDetail.forms)) {
		if (form?.data?.dfValues?.COUNTRY) {
			foundFormForCountry = form;
			foundFormKeyForCountry = key;
			break;
		}

		if (form?.data?.dfValues?.ORG_INT) {
			foundFormForCountryExpressingInterest = form;
			foundFormKeyForCountryExpressingInterest = key;
			break;
		}
	}

	const pathSegments = state?.router?.location?.pathname?.split('/') || [];

	return {
		newEntryDetail,
		currentDefinition: state?.ood?.currentDefinition,
		foundFormForCountry,
		foundFormKeyForCountry,
		foundFormForCountryExpressingInterest,
		foundFormKeyForCountryExpressingInterest,
		organOfferAttachmentTypeCbIds: state?.foedus?.organOfferAttachmentTypeCbIds,
		loggedUserPrimaryFoedusRole: state?.foedus?.loggedUserPrimaryFoedusRole,
		loggedUserCountry: state?.foedus?.loggedUserCountry,
		loggedUserFoedusPerson: state?.foedus?.loggedUserFoedusPerson,
		loggedUserRoles: state?.security?.allRoles,
		currentUserId: state?.security?.tokenInfo?.currentUserId,
		isTemporaryUser: state?.security?.tokenInfo?.currentPerson?.personalNumber === '9999999999',
		router: state?.router,
		entryId: getElementAfter(pathSegments, 'entries')
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		detail: bindActionCreators(DetailActions, dispatch)
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(ReduxStateUpdater);
